const Mahta = {
    RechargePDP:{
        productInfo: null,
        productInfoBlurClass: 'mahta-loading',
        productInfoBlurTimeout: null,

        init: function(){
            this.productInfo = document.querySelector('product-info');
            if(this.productInfo === null) return;

            this.addProductInfoBlur();
        },

        addProductInfoBlur: function() {
            if (!this.productInfo) return;

            this.productInfo.classList.add(this.productInfoBlurClass);
            this.scheduleProductInfoBlurFallback();
        },
        scheduleProductInfoBlurFallback: function() {
            if (this.productInfoBlurTimeout) {
                clearTimeout(this.productInfoBlurTimeout);
            }

            this.productInfoBlurTimeout = setTimeout(() => {
                this.productInfoBlurTimeout = null;
                this.removeProductInfoBlur();
            }, 10);
        },
        removeProductInfoBlur: function() {
            if (!this.productInfo) return;

            if (this.productInfoBlurTimeout) {
                clearTimeout(this.productInfoBlurTimeout);
                this.productInfoBlurTimeout = null;
            }

            this.productInfo.classList.remove(this.productInfoBlurClass);
        },        
    }
}